import { useMutation, useQueryClient } from '@tanstack/react-query'
import { postNewPurchaseOrderShipmentEndpoint } from '../../services/postCreateShipment'
import { sendToTmEndpoint } from '../../services/sentToTmEndpoint'
import { shipmentsModificationEndpoint } from '../../services/shipmentModifications'
import { shipmentsCancellationsEndpoint } from '../../services/shipmentCancellations'
import { shipmentsLoadModificationsEndpoint } from '../../services/loadModifications'
import { patchProductEndpoint } from '../../services/patchProduct'
import { postNewNonPoShipmentDataEndpoint } from 'services/postCreateNonPoShipment'
import { putLocationsEndpoint } from '../../services/putLocation'

export const useCreateNewPurchaseOrderShipmentQuery = () => {
  const queryClient = useQueryClient()

  return useMutation(postNewPurchaseOrderShipmentEndpoint, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['purchase_orders'] })
      queryClient.invalidateQueries({ queryKey: ['shipments-by-po'] })
    },
  })
}

export const useCreateNewNonPoShipmentQuery = () => {
  const queryClient = useQueryClient()

  return useMutation(postNewNonPoShipmentDataEndpoint, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['purchase_orders'] })
      queryClient.invalidateQueries({ queryKey: ['shipments-by-po'] })
      queryClient.invalidateQueries({ queryKey: ['shipments-by-filters'] })
    },
  })
}

export const useSendShipmentToTmQuery = () => {
  const queryClient = useQueryClient()
  return useMutation(sendToTmEndpoint, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shipments-by-po'] })
    },
  })
}

export const useShipmentsModificationQuery = () => {
  return useMutation(shipmentsModificationEndpoint)
}

export const useShipmentsCancellationsQuery = () => {
  return useMutation(shipmentsCancellationsEndpoint)
}

export const useShipmentsLoadModificationQuery = () => {
  return useMutation(shipmentsLoadModificationsEndpoint)
}

export const usePatchProductQuery = (onSuccess: any, onError: any) => {
  return useMutation(patchProductEndpoint, {
    onSuccess,
    onError,
  })
}

export const usePutLocationQuery = (onSuccess: any, onError: any) => {
  return useMutation(putLocationsEndpoint, {
    onSuccess,
    onError,
  })
}
